import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import type { AgentPerformance } from "@/lib/api";

interface AgentPerformanceTableProps {
  agents: AgentPerformance[];
}

function formatDuration(minutes: number): string {
  if (minutes === 0) return '-';
  if (minutes < 60) {
    return `${minutes}m`;
  }
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  if (hours < 24) {
    return mins > 0 ? `${hours}h ${mins}m` : `${hours}h`;
  }
  const days = Math.floor(hours / 24);
  const remainingHours = hours % 24;
  return remainingHours > 0 ? `${days}d ${remainingHours}h` : `${days}d`;
}

export function AgentPerformanceTable({ agents }: AgentPerformanceTableProps) {
  if (agents.length === 0) {
    return (
      <Card>
        <CardHeader>
          <CardTitle className="text-base">Agent Performance</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground text-center py-8">
            No agent data available
          </p>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">Agent Performance</CardTitle>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Agent</TableHead>
              <TableHead className="text-right">Closed</TableHead>
              <TableHead className="text-right">Avg Time</TableHead>
              <TableHead className="text-right">1-Response</TableHead>
              <TableHead className="text-right">Picked Up</TableHead>
              <TableHead className="text-right">Open</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {agents.map((agent) => (
              <TableRow key={agent.agentId}>
                <TableCell className="font-medium">
                  <div>
                    <div>{agent.agentName}</div>
                    {agent.agentEmail && (
                      <div className="text-xs text-muted-foreground">
                        {agent.agentEmail}
                      </div>
                    )}
                  </div>
                </TableCell>
                <TableCell className="text-right">{agent.ticketsClosed}</TableCell>
                <TableCell className="text-right">
                  {formatDuration(agent.avgResolutionTimeMinutes)}
                </TableCell>
                <TableCell className="text-right">{agent.oneResponseResolutions}</TableCell>
                <TableCell className="text-right">{agent.pickedUpFromOthers}</TableCell>
                <TableCell className="text-right">{agent.currentOpenTickets}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
